<template>
    <div>
        <table v-if="firstData && itemData.canAudi != 1 && firstData.isPlay == 0" class="info-table MT20" width="100%">
            <tr>
                <th>首款申请时间</th>
                <td>{{firstData.applyTime}}</td>
                <th>首款打款时间</th>
                <td>{{firstData.playTime}}</td>
            </tr>
            <tr>
                <th>首款打款金额</th>
                <td>{{firstData.playPriceTicketFormat}}</td>
                <th>首款打款流水号</th>
                <td>{{firstData.playPriceNo}}</td>
            </tr>
            <tr>
                <th>首款申请备注</th>
                <td colspan="3">{{firstData.applyDesc}}</td>
            </tr>
            <tr>
                <th>首款打款截图</th>
                <td colspan="3">
                    <el-image v-for="(item,index) in firstData.playPicList" :key="index" :src="item" fit="cover" :preview-src-list="firstData.playPicList"></el-image>
                </td>
            </tr>
            <tr>
                <th>首款打款备注</th>
                <td colspan="3">{{firstData.playDesc}}</td>
            </tr>
            <tr>
                <th>结款信息提交人</th>
                <td colspan="3">{{itemData.playUserName}}</td>
            </tr>
        </table>

        <table v-if="lastData && itemData.canAudi != 2" class="info-table MT20" width="100%">
            <tr>
                <th>尾款申请时间</th>
                <td>{{lastData.applyTime}}</td>
                <th>尾款打款时间</th>
                <td>{{lastData.playTime}}</td>
            </tr>
            <tr>
                <th>尾款打款金额</th>
                <td>{{lastData.playPriceTicketFormat}}</td>
                <th>尾款打款流水号</th>
                <td>{{lastData.playPriceNo}}</td>
            </tr>
            <tr>
                <th>尾款申请备注</th>
                <td colspan="3">{{lastData.applyDesc}}</td>
            </tr>
            <tr>
                <th>尾款打款截图</th>
                <td colspan="3">
                    <el-image v-for="(item,index) in lastData.playPicList" :key="index" :src="item" fit="cover" :preview-src-list="lastData.playPicList"></el-image>
                </td>
            </tr>
            <tr>
                <th>尾款打款备注</th>
                <td colspan="3">{{lastData.playDesc}}</td>
            </tr>
            <tr>
                <th>结款信息提交人</th>
                <td colspan="3">{{itemData.playUserName}}</td>
            </tr>
        </table>
        
        <template v-if="itemData.canAudi != 0">
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
                class="MT20"
            >
                <template v-if="itemData.canAudi == 1">
                    <el-row v-if="firstData" :gutter="20">
                        <el-col :span="12">
                            <div>首款申请时间: {{firstData.applyTime}}</div>
                        </el-col>
                        <el-col :span="12">
                            <div>首款打款时间: {{firstData.playTime}}</div>
                        </el-col>
                        <el-col v-if="firstData.applyDesc" :span="24" class="MT20">
                            <div>首款申请备注: {{firstData.applyDesc}}</div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="MT10">
                        <el-col :span="12">
                            <el-form-item prop="playPriceTicketFormat" label="首款打款金额:" :rules="[{required:true,message:'请填写首款打款金额'}]">
                                <el-input-number style="width:100%" v-model="formData.playPriceTicketFormat" :precision="2" :controls="false" :min="0.00" :max="99999999.99" size="medium" placeholder="请填写首款打款金额" :disabled="!firstData || firstData.isPlay == 1 ? false : true"></el-input-number>
                                <small class="color-info">首款建议支付实际筹款金额的50%=<span class="color-danger">{{(parseFloat(itemData.raisedMoneyFormat || 0) * 0.5).toFixed(2)}}</span></small>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="playPriceNo" label="首款打款流水号:" :rules="[{required:true,message:'请填写首款打款流水号'}]">
                                <el-input v-model="formData.playPriceNo" maxlength="50" size="medium" placeholder="请填写首款打款流水号" :disabled="!firstData || firstData.isPlay == 1 ? false : true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item prop="playPic">
                        <span slot="label">首款打款截图: <small>支持格式为JPG、PNG,不大于10M,最多上传3张</small></span>   
                        <div>
                            <el-upload
                                action
                                list-type="picture-card"
                                accept="image/png,image/jpeg"
                                :file-list="fileList"
                                :http-request="uploadImage"
                                :on-remove="handleRemove"
                                :before-upload="beforeUpload"
                                :disabled="uploadLoading"
                                :limit="3"
                                :on-exceed="handleExceed">
                                <el-progress v-if="progress && progress < 100" :width="120" type="circle" :percentage="progress"></el-progress>
                                <i v-else class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item prop="playDesc" label="首款打款备注:">
                        <el-input v-model="formData.playDesc" type="textarea" :rows="2" maxlength="100" show-word-limit placeholder="请填写首款打款备注"></el-input>
                    </el-form-item>
                </template>
                <template v-if="itemData.canAudi == 2">
                    <el-row v-if="lastData" :gutter="20">
                        <el-col :span="12">
                            <div>尾款申请时间: {{lastData.applyTime}}</div>
                        </el-col>
                        <el-col :span="12">
                            <div>尾款打款时间: {{lastData.playTime}}</div>
                        </el-col>
                        <el-col v-if="lastData.applyDesc" :span="24" class="MT20">
                            <div>尾款申请备注: {{lastData.applyDesc}}</div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="MT10">
                        <el-col :span="12">
                            <el-form-item prop="playPriceTicketFormat" label="尾款打款金额:" :rules="[{required:true,message:'请填写尾款打款金额'}]">
                                <el-input-number style="width:100%" v-model="formData.playPriceTicketFormat" :precision="2" :controls="false" :min="0.00" :max="99999999.99" size="medium" placeholder="请填写尾款打款金额" :disabled="!lastData || lastData.isPlay == 1 ? false : true"></el-input-number>
                                <small class="color-info">尾款应该支付除首款外的剩余筹款金额=<span class="color-danger">{{(parseFloat(itemData.raisedMoneyFormat || 0) - parseFloat(firstData && firstData.playPriceTicketFormat || 0)).toFixed(2)}}</span></small>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="playPriceNo" label="尾款打款流水号:" :rules="[{required:true,message:'请填写尾款打款流水号'}]">
                                <el-input v-model="formData.playPriceNo" maxlength="50" size="medium" placeholder="请填写尾款打款流水号" :disabled="!lastData || lastData.isPlay == 1 ? false : true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item prop="playPic">
                        <span slot="label">尾款打款截图: <small>支持格式为JPG、PNG,不大于10M,最多上传3张</small></span>
                        <div>
                            <el-upload
                                action
                                list-type="picture-card"
                                accept="image/png,image/jpeg"
                                :file-list="fileList"
                                :http-request="uploadImage"
                                :on-remove="handleRemove"
                                :before-upload="beforeUpload"
                                :disabled="uploadLoading"
                                :limit="3"
                                :on-exceed="handleExceed">
                                <el-progress v-if="progress && progress < 100" :width="120" type="circle" :percentage="progress"></el-progress>
                                <i v-else class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item prop="playDesc" label="尾款打款备注:">
                        <el-input v-model="formData.playDesc" type="textarea" :rows="2" maxlength="100" show-word-limit placeholder="请填写尾款打款备注"></el-input>
                    </el-form-item>
                </template>
            </el-form>
            <!-- <el-row :gutter="20" class="MT20">
                <el-col :span="12">
                    <div>
                        总打款金额: 
                        <span>{{formData.playPriceTicket}}</span>
                    </div>
                </el-col>
            </el-row> -->
        </template>
        <el-row :gutter="20" class="MT20">
            <el-col :span="12">
                <div>
                    总打款金额: 
                    <span class="color-danger">{{parseFloat(firstData && firstData.playPriceTicketFormat || 0) + parseFloat(lastData && lastData.playPriceTicketFormat || 0)}}</span>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {uploadImg} from '@/assets/js/commonApi.js';
const defaultFormData = {
    playPriceTicketFormat:'',
    playPriceNo:'',
    playPic:[],
    playDesc:'',
    audiType:1,
    playTime:''
}
export default {
    props:{
        itemData:{
            type: Object,
            default: null
        },
        btnLoading: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            formData:{
                ...defaultFormData 
            },
            fileList: [],
            uploadLoading: false,
            progress:null,
        }
    },
    computed:{
        //首款
        firstData(){
            if( this.itemData.canAudi == 1 ){
                this.formData = {
                    ...defaultFormData,
                    ...this.itemData.downPaymentReceivables,
                    audiType:1,
                    playPic: this.itemData.downPaymentReceivables.playPicList || [],
                }
                this.fileList = this.itemData.downPaymentReceivables.playPicList ? this.itemData.downPaymentReceivables.playPicList.map( v => {return {url: v}}) : [];
            }
            return this.itemData.downPaymentReceivables || null
        },
        //尾款
        lastData(){
            if( this.itemData.canAudi == 2 ){
                this.formData = {
                    ...defaultFormData,
                    ...this.itemData.retainageReceivables,
                    audiType:2,
                    playPic: this.itemData.retainageReceivables.playPicList || [],
                }
                this.fileList = this.itemData.retainageReceivables.playPicList ? this.itemData.retainageReceivables.playPicList.map( v => {return {url: v}}) : [];
            }
            return this.itemData.retainageReceivables || null
        },
    },
    methods:{
        handleExceed(files, fileList) {
            this.$message.warning('最多上传3张图片');
        },
        handleRemove(file, fileList) {
            const _index = this.fileList.findIndex(v => v === file);

            this.formData.playPic = this.formData.playPic.filter( (v,i) => i !== _index);

            this.fileList = fileList; 
        },
        beforeUpload(file){
            this.fileList = this.fileList.filter( v => v !== file)
        },
        async uploadImage(req){
            const {
                file,
                file: { type, size },
            } = req;

            //格式检查
            const formatVerified =
                type === "image/jpeg" || file.type === "image/png";
            if (!formatVerified) {
                this.$message.error("图片格式错误,请重新上传");
                return;
            }
            //大小检查
            const bytesVerified = size / 1024 / 1024 < 10;
            if (!bytesVerified) {
                this.$message.error("图片尺寸错误,请重新上传");
                return;
            }

            // 上传图片
            const formData = new FormData();
            formData.append("file", file);
             
            this.uploadLoading = true;
            const res = await uploadImg(formData,ev => {
                this.progress = Math.floor((ev.loaded / ev.total) * 100);
            }).finally(() => {
                this.uploadLoading = false;
            });

            const {state,result,msg} = res.data;
            if(state == 1){
                this.fileList.push({
                    url:result.urlFull
                });
                this.formData.playPic = this.fileList.map(v => v.url);
            }else{
                this.$message.error( msg || '上传失败');
            }
        },
        onSubmit(callback){
            if(this.$refs.formData) {
                this.$refs["formData"].validate((valid) => {
                    if (valid) {
                        this.$confirm('确定提交结款信息？', '提示', {
                            type: 'warning',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$emit('update:btnLoading', true) ;
                            this.$request({
                                url: '/raise/receivables/audi/save',
                                data: {...this.formData,activityId: this.itemData.id},
                                method: "post",
                            })
                                .then((res) => {
                                    const { state, msg } = res.data;
                                    if (state == 1) {
                                        if(callback) callback();
                                        this.$refs.formData.resetFields();
                                        this.fileList = [];
                                    } else {
                                        this.$message.error(msg || "操作失败,请重试");
                                    }
                                })
                                .catch(() => {
                                    this.$message.error("操作失败,请重试");
                                })
                                .finally(() => {
                                    this.$emit('update:btnLoading', false) ;
                                });
                        }).catch(() => {})    
                    } else {
                        return false;
                    }
                });
            }else{
                if(callback) callback();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-table{
    .el-image{
        width: 60px;
        height: 60px;
        margin-right: 5px;
    }
}
</style>